import React from 'react';
import CssBaseline from '@material-ui/core/CssBaseline';

import Paper from '@material-ui/core/Paper';

import Grid from '@material-ui/core/Grid';
import workImage from '../Images/work-in-progress.jpg';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import background from '../Images/bg-intro.jpg';

const useStyles = makeStyles((theme) => ({
  image: {
    backgroundImage: `url(${workImage})`,
    backgroundRepeat: 'no-repeat',
    minHeight: '50vh',
    backgroundColor:
      theme.palette.type === 'light'
        ? theme.palette.grey[50]
        : theme.palette.grey[900],
    backgroundSize: 'cover',
    backgroundPosition: 'center',
  },
  gridBackground: {
    backgroundImage: `url(${background})`,
    backgroundSize: 'cover',
  },
  paper: {
    color: 'white',
    margin: theme.spacing(8, 4),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'left',
  },
  mainTitle: {
    [theme.breakpoints.down('xs')]: {
      fontSize: '2.5rem',
    },
  },
}));

const HeaderHero = (props) => {
  const classes = useStyles();
  const { post } = props;
  return (
    <Grid container component="main" className={classes.root}>
      <CssBaseline />
      <Grid item xs={12} sm={4} md={7} className={classes.image} />
      <Grid
        item
        xs={12}
        sm={8}
        md={5}
        className={classes.gridBackground}
        component={Paper}
        elevation={6}
        square
      >
        <div className={classes.paper}>
          {' '}
          <Typography
            className={classes.mainTitle}
            component="h1"
            variant="h3"
            color="inherit"
            gutterBottom
          >
            {post.title}
          </Typography>
          <Typography variant="h5" color="inherit" paragraph>
            {post.description}
          </Typography>
        </div>
      </Grid>
    </Grid>
  );
};
export default HeaderHero;
